import script from "./Initiator.vue?vue&type=script&lang=ts&setup=true"
export * from "./Initiator.vue?vue&type=script&lang=ts&setup=true"

import "./Initiator.vue?vue&type=style&index=0&id=1e665988&lang=scss"

const __exports__ = script;

export default __exports__